var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"player",staticClass:"player",attrs:{"preload":"auto","src":_vm.data,"autoplay":"","muted":""},domProps:{"muted":true},on:{"click":_vm.handleClickPlayer}})])}
var staticRenderFns = []

export { render, staticRenderFns }